"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _common = require("../common");

var _lib = require("../lib");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Timer =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Timer, _PureComponent);

  _createClass(Timer, null, [{
    key: "addLeadingZero",
    value: function addLeadingZero(value) {
      if (value < 10) {
        return "0".concat(value.toString());
      }

      return value;
    }
  }, {
    key: "asTime",
    value: function asTime(target, startAt) {
      if ((0, _lib.isObj)(target) && !(target instanceof Date)) {
        return (0, _moment["default"])(startAt).add(target);
      }

      return (0, _moment["default"])(target);
    }
  }]);

  function Timer(props) {
    var _this;

    _classCallCheck(this, Timer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Timer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onStart", function () {
      var onStart = _this.props.onStart;

      if (onStart) {
        onStart();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStop", function () {
      var onStop = _this.props.onStop;

      if (onStop) {
        onStop();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onComplete", function () {
      var onComplete = _this.props.onComplete;

      if (onComplete) {
        onComplete();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getDurationFormat", function () {
      var timeUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'seconds';
      var remainingTime = _this.state.remainingTime;
      var leadingZero = _this.props.leadingZero;

      var value = _moment["default"].duration(remainingTime).get(timeUnit);

      return leadingZero ? Timer.addLeadingZero(value) : value;
    });

    _defineProperty(_assertThisInitialized(_this), "setTimer", function () {
      _this.timer = setInterval(_this.tick, _this.props.interval);
    });

    _defineProperty(_assertThisInitialized(_this), "clearTimer", function () {
      if (_this.timer) {
        clearInterval(_this.timer);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "start", function () {
      var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.target;

      _this.clearTimer();

      var startAt = (0, _moment["default"])();
      var targetTime = Timer.asTime(target, startAt);

      _this.setState({
        startAt: startAt,
        targetTime: targetTime,
        remainingTime: _this.calculateRemainingTime(targetTime)
      }, function () {
        _this.onStart();
      });

      _this.setTimer();
    });

    _defineProperty(_assertThisInitialized(_this), "pause", function () {
      var _this$state = _this.state,
          remainingTime = _this$state.remainingTime,
          pauseAt = _this$state.pauseAt;

      if (remainingTime && !pauseAt) {
        _this.clearTimer();

        _this.setState({
          pauseAt: (0, _moment["default"])()
        }, function () {
          var onPause = _this.props.onPause;

          if (onPause) {
            onPause();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resume", function () {
      var _this$state2 = _this.state,
          remainingTime = _this$state2.remainingTime,
          pauseAt = _this$state2.pauseAt,
          startAt = _this$state2.startAt;

      if (remainingTime && pauseAt && startAt) {
        var pauseDuration = (0, _moment["default"])().diff(pauseAt);
        var newStartAt = startAt.add(pauseDuration);

        _this.setState({
          pauseAt: null,
          targetTime: Timer.asTime(_this.props.target, newStartAt)
        }, function () {
          _this.setTimer();

          var onResume = _this.props.onResume;

          if (onResume) {
            onResume();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "stop", function () {
      _this.clearTimer();

      if (_this.state.remainingTime > 0) {
        _this.setState({
          remainingTime: 0
        }, function () {
          _this.onStop();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateRemainingTime", function () {
      var targetTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.targetTime;
      var remaining = -1 * (0, _moment["default"])().diff(targetTime);

      if (remaining <= _this.props.interval) {
        return 0;
      }

      return remaining;
    });

    _defineProperty(_assertThisInitialized(_this), "tick", function () {
      var remainingTime = _this.calculateRemainingTime();

      if (remainingTime <= _this.props.interval) {
        _this.clearTimer();
      }

      _this.setState({
        remainingTime: remainingTime
      }, function () {
        if (remainingTime <= _this.props.interval) {
          _this.onComplete();
        }
      });
    });

    var _target = props.target;
    _this.state = {
      prevProps: {
        target: _target
      },
      startAt: null,
      targetTime: Timer.asTime(_target),
      remainingTime: 0,
      pauseAt: null
    };
    return _this;
  }

  _createClass(Timer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var autoStart = this.props.autoStart;

      if (autoStart) {
        this.start();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state3 = this.state,
          startAt = _this$state3.startAt,
          remainingTime = _this$state3.remainingTime,
          targetTime = _this$state3.targetTime,
          pauseAt = _this$state3.pauseAt;
      return (0, _lib.getRenderProps)(children, {
        startAt: startAt,
        pauseAt: pauseAt,
        targetTime: targetTime,
        remainingTime: remainingTime,
        years: this.getDurationFormat('years'),
        months: this.getDurationFormat('months'),
        days: this.getDurationFormat('days'),
        hours: this.getDurationFormat('hours'),
        minutes: this.getDurationFormat('minutes'),
        seconds: this.getDurationFormat('seconds'),
        start: this.start,
        pause: this.pause,
        resume: this.resume,
        stop: this.stop,
        isPaused: !!pauseAt
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var target = props.target;
      return {
        // Store the previous props in state
        prevProps: {
          target: target
        },
        targetTime: prevProps.target !== target ? Timer.asTime(target, state.startAt) : state.targetTime
      };
    }
  }]);

  return Timer;
}(_react.PureComponent);

exports["default"] = Timer;

_defineProperty(Timer, "displayName", 'Timer');

_defineProperty(Timer, "propTypes", {
  interval: _propTypes["default"].number,
  children: _common.customPropTypes.render,
  onStart: _propTypes["default"].func,
  onStop: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onResume: _propTypes["default"].func,
  onComplete: _propTypes["default"].func,
  autoStart: _propTypes["default"].bool,
  leadingZero: _propTypes["default"].bool,
  target: _propTypes["default"].oneOfType([_propTypes["default"].shape({
    years: _propTypes["default"].number,
    months: _propTypes["default"].number,
    days: _propTypes["default"].number,
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number,
    seconds: _propTypes["default"].number
  }), _propTypes["default"].instanceOf(Date)]).isRequired
});

_defineProperty(Timer, "defaultProps", {
  interval: 1000,
  children: null,
  onStart: null,
  onStop: null,
  onPause: null,
  onResume: null,
  onComplete: null,
  autoStart: false,
  leadingZero: false
});